import { render, staticRenderFns } from "./ConsultUpvoteStatus.vue?vue&type=template&id=0e981a98&scoped=true&"
import script from "./ConsultUpvoteStatus.vue?vue&type=script&lang=js&"
export * from "./ConsultUpvoteStatus.vue?vue&type=script&lang=js&"
import style0 from "./ConsultUpvoteStatus.vue?vue&type=style&index=0&id=0e981a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e981a98",
  null
  
)

export default component.exports